/* eslint-disable react/prop-types */
import React from 'react'
import moment from 'moment'
import { Line } from 'react-chartjs-2'
import { withTranslation } from 'react-i18next'

import './MemberStatsGraph.scss'

class MemberStatsGraph extends React.Component {
  state = {
    day: 0,
    dataArray: [],
    priorMonthStudents: 0,
    newToday: 0,
    totalNew: 0,
  }

  componentDidMount() {
    this.setState({ day: parseInt(moment().format('D'), 10) }, () => {
      this._setDataArray()
    })
  }

  render() {
    const { t } = this.props
    const data = {
      labels: this.state.dataArray.map(_v => ''),
      datasets: [
        {
          label: 'member',
          fill: true,
          lineTension: 0.2,
          backgroundColor: 'rgba(51,217,178,0.2)',
          borderColor: 'rgba(51,217,178,0.7)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(51,217,178,0.7)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointHoverBackgroundColor: 'rgba(51,217,178,0.7)',
          pointHoverBorderColor: 'rgba(220,220,220,0.7)',
          pointHoverBorderWidth: 1,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.dataArray,
        },
      ],
    }

    return (
      <div id='MemberStatsGraph'>
        <div className='today-lead-container'>
          <p className='lead-count'>
            {this.state.newToday === 0 ? '0' : `+${this.state.newToday}`}
          </p>
          <p className='lead-label'>{t('leads.common.today')}</p>
        </div>
        <div className='total-lead-container'>
          <p className='lead-count'>{this.state.totalNew}</p>
          <p className='lead-label'>{t('leads.memberStats.totalNewMembers')}</p>
        </div>
        <Line
          data={data}
          options={{
            maintainAspectRatio: false,
            scales: {
              x: {
                ticks: { display: false },
                grid: {
                  display: false,
                  drawBorder: true,
                  borderWidth: 3,
                  borderColor: '#2b3843',
                },
              },
              y: {
                beginAtZero: true,
                ticks: {
                  // max: 100,
                  display: false,
                },
                grid: {
                  display: false,
                  drawBorder: true,
                  borderWidth: 3,
                  borderColor: '#2b3843',
                },
              },
            },
            layout: {
              padding: {
                left: 0,
                right: 10,
                top: 3,
                bottom: 0,
              },
            },
            plugins: {
              legend: { display: false },
              tooltip: {
                displayColors: false,
                callbacks: {
                  label: (context) => {
                    const month = moment().format('M')
                    const day = context.dataIndex + 1
                    const nr = context.raw

                    return `${month}/${day}: ${nr}`
                  },
                },
              },
            },
          }}
        />
      </div>
    )
  }

  _setDataArray = () => {
    const { day } = this.state
    const { dates } = this.props
    const priorDates = []
    const workingDates = []
    const dailyCount = []
    let aggregator = 0
    const data = []
    dates.forEach(date => {
      if (
        moment()
          .endOf('day')
          .diff(moment(date), 'days') >= day
      ) {
        priorDates.push(date)
      } else {
        workingDates.push(date)
      }
    })
    this.setState({ priorMonthStudents: priorDates.length }, () => {
      for (let i = 1; i <= day; i++) {
        const perDay = workingDates.filter(
          date =>
            moment()
              .endOf('day')
              .diff(moment(date), 'days') ===
            day - i
        )
        dailyCount.push(perDay.length)
      }
      aggregator = priorDates.length
      for (let i = 0; i < dailyCount.length; i++) {
        aggregator += dailyCount[i]
        data.push(aggregator)
      }
      this.setState({
        dataArray: data,
        newToday:
          data.length > 1
            ? data[data.length - 1] - data[data.length - 2]
            : data[data.length - 1] - aggregator,
        totalNew: data[data.length - 1] - priorDates.length,
      })
    })
  }
}

export default withTranslation()(MemberStatsGraph)
